<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
// import NavTop from "./components/NavTop";
export default {
  name: "App",
  // components: {
  //   NavTop,
  // },
  data () {
    return {};
  },
  methods: {},
  beforeCreate(){
  // //判断是否横屏
  //   let screenWidth = document.documentElement.clientWidth || document.body.clientWidth;
  //   let screenHeight = document.documentElement.clientHeight || document.body.clientHeight;
  //   if( screenWidth / screenHeight > 1){
  //     this.$store.commit('editLandscape',true)
  //   };
  //   // 判断是否https
  //   if (location.href.indexOf("http://www.soargift.com") === 0) {
  //     this.$store.commit("isHttpsFunc", false);
  //   } else if (location.href.indexOf("https://www.soargift.com") === 0) {
  //     this.$store.commit("isHttpsFunc", true);
  //   }
  //
  //   // 判断是否PC端
  //   let userAgentInfo = navigator.userAgent;
  //   let Agents = [
  //     "Android",
  //     "iPhone",
  //     "SymbianOS",
  //     "Windows Phone",
  //     "iPad",
  //     "iPod",
  //   ];
  //   for (let v = 0; v < Agents.length; v++) {
  //     if (userAgentInfo.indexOf(Agents[v]) > 0) {
  //       this.$store.commit("isPC", false);
  //       break;
  //     }
  //   }
  },
  created () {
    // console.group('created 创建完毕状态===============》');
  },
  beforeMount () {
    // console.group('beforeMount 挂载前状态===============》');
  },
  mounted () {
    // console.group('mounted 挂载结束状态===============》');
  },
  beforeUpdate () {
    // console.group('beforeUpdate 更新前状态===============》');
  },
  updated () {
    // console.group('updated 更新完成状态===============》');
  },
  beforeDestroy () {
    // console.group('beforeDestroy 销毁前状态===============》');
  },
  destroyed () {
    // console.group('destroyed 销毁完成状态===============》');
  },
}
</script>

<style>
@import "assets/css/common.css";
@import "assets/css/reset.css";
#app {
  font-family: Microsoft YaHei, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: white;
  box-sizing: border-box;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue